import { useFormContext, Controller } from 'react-hook-form';
import { Calendar } from 'components/common/Calendar';
import { IFormCalendarProps } from './types';

export const FormCalendar: React.FC<IFormCalendarProps> = ({
  defaultValue = new Date(),
  name,
  rules,
  ...calendarProps
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      defaultValue={defaultValue}
      rules={rules}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Calendar
          value={field.value}
          helperText={error?.message}
          onChange={field.onChange}
          inputRef={field.ref}
          textFieldProps={{ error: !!error, helperText: error?.message }}
          {...calendarProps}
        />
      )}
    />
  );
};
